import { useAtom } from 'jotai';
import * as state from '../state';
import { SUPPORT_ERROR_MESSAGE } from '@/constants';
import Button from '@mui/material/Button';
import { GenericConfirmationDialog } from '@/components/Analysis/shared/GeneriConfirmationDialog';

export const PipeSpecUploadErrorDialog = () => {
  const [pipeSpecUploadState, setPipeSpecUploadState] = useAtom(state.pipeSpecUploadState);

  const onClose = () => {
    setPipeSpecUploadState((previous) => ({
      ...previous,
      error: undefined,
      inputCsv: undefined,
      state: 'idle',
    }));
  };

  const errorMessage =
    typeof pipeSpecUploadState.error?.message === 'string'
      ? pipeSpecUploadState.error?.message
      : SUPPORT_ERROR_MESSAGE;

  const isAssemblyUpdateError = errorMessage.includes('Failed to Update Assemblies');
  const title = isAssemblyUpdateError ? 'Failed to Update Assemblies' : 'Validation Error';

  return (
    <GenericConfirmationDialog
      open={pipeSpecUploadState.state === 'generic-error'}
      onClose={onClose}
      title={title}
      description={errorMessage}
      body={<></>}
    >
      <Button variant="contained" onClick={onClose}>
        Got it
      </Button>
    </GenericConfirmationDialog>
  );
};
